import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';

import { SportMatch } from 'components/play/Types/Types';

export function MatchesList() {
    const playStore = useSelector((state: RootState) => state.playStore);

    const normalMatchName = (sportMatch: SportMatch) => (
        <div className="row row-match" key={`match_${sportMatch.id}`}>
            <div className="match-info">
                <span className="competitor">
                    {sportMatch.order + 1}. {sportMatch.sport_competitors[0].name}
                    {''}
                </span>
                <span className="competitor">- {sportMatch.sport_competitors[1].name}</span>
            </div>
        </div>
    );

    const specialMatchName = (sportMatch: SportMatch) => (
        <div className="row row-match row-match-special" key={`match_${sportMatch.id}`}>
            <div className="match-info-special">
                <span className="competitor">
                    {sportMatch.order + 1}. {sportMatch.sport_competitors[0].name}
                </span>
                <span className="competitor">- {sportMatch.sport_competitors[1].name}</span>
            </div>
        </div>
    );

    return (
        <div className="matches-list-wrapper">
            <div className="matches-list">
                {playStore.lottery.sportSequence.sport_matches.map((sportMatch, index) =>
                    index === 14 ? specialMatchName(sportMatch) : normalMatchName(sportMatch)
                )}
            </div>
        </div>
    );
}
